@if (thread().status !== 'hidden') {
  <section class="comments" aria-labelledby="blog-comments-heading">
    <header class="comments__header">
      <h2 id="blog-comments-heading" class="comments__heading">{{ copy.heading }}</h2>
      @if (page(); as page) {
        <span class="comments__count">{{ copy.count(page.total) }}</span>
      }
    </header>

    @switch (thread().status) {
      @case ('loading') {
        <div class="comments__skeleton" aria-busy="true">
          @for (row of skeletonRows; track row) {
            <div class="comments-skeleton__row" aria-hidden="true">
              <span class="comments-skeleton__avatar"></span>
              <div class="comments-skeleton__body">
                <span class="comments-skeleton__line comments-skeleton__line--meta"></span>
                <span class="comments-skeleton__line"></span>
                <span class="comments-skeleton__line comments-skeleton__line--short"></span>
              </div>
            </div>
          }
        </div>
      }
      @case ('error') {
        <div class="comments__load-error">
          <p>{{ copy.loadError }}</p>
          <app-button variant="ghost" size="sm" (click)="retry()">{{ copy.retry }}</app-button>
        </div>
      }
      @case ('ready') {
        @if (page(); as page) {
          @if (page.comments.length === 0) {
            <p class="comments__empty">{{ copy.empty }}</p>
          } @else {
            <ol class="comments__list">
              @for (comment of page.comments; track comment.id) {
                <li class="comment" [class.comment--replying]="replyTo()?.id === comment.id">
                  <ng-container
                    [ngTemplateOutlet]="commentTpl"
                    [ngTemplateOutletContext]="{ $implicit: comment }"
                  />
                  @if (!formClosed()) {
                    <button type="button" class="comment__reply" (click)="reply(comment)">
                      {{ copy.reply }}
                    </button>
                  }
                  @if (comment.replies.length > 0) {
                    <ol class="comment__replies">
                      @for (child of comment.replies; track child.id) {
                        <li class="comment comment--reply">
                          <ng-container
                            [ngTemplateOutlet]="commentTpl"
                            [ngTemplateOutletContext]="{ $implicit: child }"
                          />
                        </li>
                      }
                    </ol>
                  }
                </li>
              }
            </ol>
          }

          @if (hasMore()) {
            <div class="comments__more">
              <app-button variant="ghost" size="sm" [loading]="loadingMore()" (click)="loadMore()">
                {{ copy.loadMore }}
              </app-button>
              @if (loadMoreFailed()) {
                <p class="comments__more-error" role="alert">{{ copy.loadError }}</p>
              }
            </div>
          }
        }
      }
    }

    @if (thread().status !== 'loading') {
      <div class="comments__form" #formSection>
        @if (formClosed()) {
          <p class="comments__closed" role="status">{{ copy.errors.closed }}</p>
        } @else {
          @defer (on viewport; prefetch on idle) {
            <app-article-comment-form
              [slug]="slug()"
              [replyTo]="replyTo()"
              [focusRequest]="focusRequest()"
              (cancelReply)="cancelReply()"
              (sent)="onSent($event)"
              (closed)="onClosed()"
            />
          } @placeholder {
            <h3 class="comments__form-heading">{{ copy.formHeading }}</h3>
          }
        }
      </div>
    }
  </section>
}

<ng-template #commentTpl let-comment>
  <article class="comment__item">
    <div class="comment__meta">
      <span class="comment__avatar" aria-hidden="true">{{ initial(comment.authorName) }}</span>
      <span class="comment__author">{{ comment.authorName }}</span>
      @if (comment.isStaff) {
        <span class="comment__badge">{{ copy.staffBadge }}</span>
      }
      <time class="comment__date" [attr.datetime]="comment.createdAt">{{
        comment.createdAt | blogDate
      }}</time>
      @if (comment.edited) {
        <span class="comment__edited">{{ copy.edited }}</span>
      }
    </div>
    <!-- B108: siempre texto, jamás [innerHTML]. -->
    <p class="comment__body">{{ comment.body }}</p>
  </article>
</ng-template>
